import React from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import { SearchResultPartyDetails } from '@Entities/party-details'
import SongwriterCatalogBuilderRow from '@Scenes/SongwriterScene/SongwriterCatalogBuilderScene/SongwriterCatalogBuilderResults/SongwriterCatalogBuilderTable/SongwriterCatalogBuilderRow'
import { Maybe } from '@Types'

interface SongwriterLinkTableProps {
    data: SearchResultPartyDetails[]
    linkedWriterIpIds: Set<number>
    onTitleClick: (partyDetails: SearchResultPartyDetails) => void
    onWriterToggle: (isLinked: boolean, writerIpId: number) => void
    requestAnUpdate?(selectedWriter: { ipId: Maybe<string>; writerName: string }): void
}
const SongwriterCatalogBuilderTable = ({
    data,
    onTitleClick,
    linkedWriterIpIds,
    onWriterToggle,
}: SongwriterLinkTableProps) => (
    <table className="songwriter-link-table">
        <colgroup>
            <col className="songwriter-name-col" />
            <col className="songwriter-toggle-col" />
        </colgroup>
        <thead>
            <tr>
                <td>Writer Name</td>
                <td>Catalog Status</td>
                <td />
            </tr>
        </thead>
        <tbody>
            {data.map((writer, index) => (
                <SongwriterCatalogBuilderRow
                    key={index}
                    writer={writer}
                    onWriterToggle={onWriterToggle}
                    onTitleClick={onTitleClick}
                    isChecked={linkedWriterIpIds.has(Number(writer.ipId))}
                />
            ))}
        </tbody>
    </table>
)

export default observer(SongwriterCatalogBuilderTable)
